<template>
  <MGamePage :game-id="gameId" />
</template>

<script setup lang="ts">
import MGamePage from '@st/casino/components/GamePage/MGamePage.vue'

const route = useRoute()
const gameId = computed(() => Number(route.params.id))

definePageMeta({
  layout: 'empty',
  inGame: true,
  middleware: 'game',
})
useSeoData('casino-game')
</script>
